<template>
  <div class="html-container">
    <iframe
      src="/waple/chatbot.html"
      width="100%"
      height="100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'Chatbot',
  mounted() {
    // 챗봇 진입 시 부모 body 폭 풀기
    document.body.style.width = '100%';
    document.body.style.maxWidth = 'none';
  },
  beforeDestroy() {
    // 다른 페이지로 이동 시 원래 스타일로 복원 (필요 시)
    document.body.style.width = '';
    document.body.style.maxWidth = '';
  }
}
</script>

<style scoped>
.iframe-wrapper {
  width: 100%;
  height: 100vh;
}
</style>
